import React, { useState } from 'react';

interface TextAreaProps {
  variant?: string;
  attributes?: Record<string, any>;
  onClick?: () => void;
  className?: string;
  leftIcon?: string;
  rightIcon?: string;
  showCharacterCount?: boolean;
  maxLength?: number;
}

export const TextArea: React.FC<TextAreaProps> = ({
  variant,
  attributes,
  onClick,
  className,
  leftIcon,
  rightIcon,
  showCharacterCount = false,
  maxLength,
}) => {
  const baseClasses = 'px-4 py-2 rounded text-dark bg-bg_grey_light transition-colors duration-300 font-sora w-full min-h-[100px] resize-y';

  const variantClasses: Record<string, any> = {
    'filled': '',
  };

  const currentLength = attributes?.value?.length || 0;

  return (
    <div className="relative">
      {/* Left Icon */}
      {leftIcon && (
        <div className="absolute left-3 top-3 z-10">
          <img
            src={leftIcon}
            alt=""
            className="w-5 h-5"
            onError={(e) => {
              console.error('Left icon failed to load:', leftIcon);
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      )}

      {/* TextArea Field */}
      <textarea
        className={`${baseClasses} ${variant && variantClasses[variant] || ''} ${className} ${leftIcon ? 'pl-10' : ''
          } ${rightIcon ? 'pr-10' : ''
          }`}
        onClick={onClick}
        maxLength={maxLength}
        {...attributes}
      />

      {/* Right Icon */}
      {rightIcon && (
        <div className="absolute right-3 top-3 z-10">
          <img
            src={rightIcon}
            alt=""
            className="w-5 h-5"
            onError={(e) => {
              console.error('Right icon failed to load:', rightIcon);
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      )}

      {/* Character Count */}
      {showCharacterCount && maxLength && (
        <div className="absolute right-3 bottom-2 text-xs text-grey_dark">
          {currentLength}/{maxLength}
        </div>
      )}
    </div>
  );
};

export default TextArea;